// Product analytics for the pricing funnel (docs/pricing-and-entitlements.md):
//
//   pricing_viewed -> plan_selected -> checkout_started -> purchase_completed
//   -> meeting_started
//
// The browser reports what only it sees (page views, clicks, checkout
// windows). Confirmed purchases, cancellations and meetings are also logged
// by the backend as ANALYTICS_EVENT lines, which stay authoritative.
//
// No vendor SDK is bundled. Each event is:
//   * pushed onto window.dataLayer when a tag manager put one there, and
//   * dispatched as a `krishvaq:analytics` DOM event, so any script (or a
//     test) can listen without this file knowing about it.
// Tracking never throws - a broken analytics sink must not break a checkout.

export const ANALYTICS_EVENTS = {
  PRICING_VIEWED: 'pricing_viewed',
  PLAN_SELECTED: 'plan_selected',
  CHECKOUT_STARTED: 'checkout_started',
  PURCHASE_COMPLETED: 'purchase_completed',
  PURCHASE_FAILED: 'purchase_failed',
  MEETING_STARTED: 'meeting_started',
  CREDIT_LOW_BANNER_VIEWED: 'credit_low_banner_viewed',
  EXTRA_MEETING_CLICKED: 'extra_meeting_clicked',
  UPGRADE_CLICKED: 'upgrade_clicked',
  SUBSCRIPTION_CANCELLED: 'subscription_cancelled',
};

export const ANALYTICS_DOM_EVENT = 'krishvaq:analytics';

export function track(event, properties = {}) {
  try {
    if (typeof window === 'undefined') return;
    const payload = { event, ...properties, timestamp: new Date().toISOString() };

    if (Array.isArray(window.dataLayer)) window.dataLayer.push(payload);
    window.dispatchEvent(new CustomEvent(ANALYTICS_DOM_EVENT, { detail: payload }));
  } catch {
    // Never let analytics fail the user's action.
  }
}
